export default __webpack_public_path__ + "a097e13e2f80c51ff45e8cd8489d9df4.svg";